import { initializeApp } from "firebase/app"
import { connectAuthEmulator, getAuth } from "firebase/auth"
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore"
import { connectStorageEmulator, getStorage } from "firebase/storage"
import { connectFunctionsEmulator, getFunctions } from "firebase/functions"
import prodConfig from "./config.prod"
import devConfig from "./config.dev"

// Add VITE_FIREBASE_CONFIG=production on Cloudflare "Production" environment to deploy using prod config
const firebaseConfig =
    import.meta.env.VITE_FIREBASE_CONFIG === "production"
        ? prodConfig
        : devConfig

export const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)

const shouldUseEmulators = import.meta.env.VITE_USE_EMULATORS === "true"

if (shouldUseEmulators) {
    // HMR can re-run module init; guard to avoid duplicate emulator connection errors.
    const emulatorFlag = "__cmhtFirebaseEmulatorsConnected__"
    const globalScope = globalThis as typeof globalThis &
        Record<string, boolean>

    if (!globalScope[emulatorFlag]) {
        connectAuthEmulator(auth, "http://127.0.0.1:9099")
        connectFirestoreEmulator(db, "127.0.0.1", 8080)
        connectStorageEmulator(storage, "127.0.0.1", 9199)
        connectFunctionsEmulator(functions, "127.0.0.1", 5001)
        globalScope[emulatorFlag] = true
    }
}
